import { render, staticRenderFns } from "./CollapseSchedule.vue?vue&type=template&id=1280e4d8&scoped=true"
import script from "./CollapseSchedule.vue?vue&type=script&lang=js"
export * from "./CollapseSchedule.vue?vue&type=script&lang=js"
import style0 from "./CollapseSchedule.vue?vue&type=style&index=0&id=1280e4d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1280e4d8",
  null
  
)

export default component.exports